module.exports = __webpack_public_path__ + "img/person_shrugging.091e50f2.gif";